const configuredBridgeUrl = process.env.REACT_APP_PRINT_BRIDGE_URL || "http://127.0.0.1:8765";

export const PRINTER_BRIDGE_URL = configuredBridgeUrl.replace(/\/+$/, "");
